export default "__VITE_ASSET__hHohAXhd__"